import type { FaireProductEntity } from "../../entity_types/product";

export const p_a8q29zp7r2: FaireProductEntity = {
  token: "p_a8q29zp7r2",
  type: "product",
  name: "Ridge Rush",
  brandToken: "b_2ncsmapy03",
  brandName: "Olipop",
  imageUrl:
    "https://cdn.faire.com/fastly/3744b2fd063a535527e6daebb758bb634a14dc1acaa3c393d2912dc81754c48a.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cfcf7c49af00d930b5d2061a72b8563282762083cfd79b870650fa0b17cfc6a7.png",
    "https://cdn.faire.com/fastly/8217d645a2a9c09cb08c9516b6d7337db8ac35e60d58eddce3e8bd25bf5cdc0d.png",
    "https://cdn.faire.com/fastly/5e67f34049c020a12700fda3737a37d48695bafeee2b681122d54759fdc1640b.png",
    "https://cdn.faire.com/fastly/3afd04ca5111124ca96db41eccd2d4d4fb5c23c0b211334508cdf649a3792812.png",
    "https://cdn.faire.com/fastly/721c9578ed7ff5fe2c87e5ada29a2dc6bcf33cd2bf571a53a5ea4704b74cb812.png",
  ],
  priceDollars: 28.99,
  description:
    "Unleash Ridge Rush's invigorating blend of lemon, lime and orange juices for an energizing burst of flavor.",
  tags: [],
  msrpDollars: 57.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-30T17:24:14.509Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
